import { render, staticRenderFns } from "./RequestInfoCard.vue?vue&type=template&id=0efbc322&scoped=true&"
import script from "./RequestInfoCard.vue?vue&type=script&lang=js&"
export * from "./RequestInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestInfoCard.vue?vue&type=style&index=0&id=0efbc322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbc322",
  null
  
)

export default component.exports